export default {
	namespaced: true,
	state: () => ({
		levelInfo: { score: 0, next_level: { score: 0 }, base_privilege: [] },
		dailyTaskList: [],
		onceTaskList: [],
	}),
	mutations: {
		SetLevelInfo(state, payload) {
			state.levelInfo = payload;
		},
		SetDailyTaskList(state, payload) {
			state.dailyTaskList = payload;
		},
		SetOnceTaskList(state, payload) {
			state.onceTaskList = payload;
		},
	},
	actions: {},
	getters: {
		LevelInfo(state) {
			return state.levelInfo;
		},
		DailyTaskList(state) {
			return state.dailyTaskList;
		},
		OnceTaskList(state) {
			return state.onceTaskList;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/App/modules/growth-center.js